import React from 'react';
import * as PropTypes from 'prop-types';
import {InputLabelStyle} from './input.styled';

export const InputLabel = ({text, required, extension, child, activeError, alignRight}) => {
	return (
		<>
			<InputLabelStyle className="input-title" alignRight={alignRight}>
				{text}
				{required ? (
					<span className={'required-extension ' + (activeError === false ? 'inactive' : '')}>
						{extension || '*'}
					</span>
				) : null}
			</InputLabelStyle>
			{child}
		</>
	);
};

InputLabel.propTypes = {
	text: PropTypes.string,
	required: PropTypes.bool,
	extension: PropTypes.string,
	child: PropTypes.element,
	activeError: PropTypes.bool,
	alignRight: PropTypes.bool,
};

InputLabel.defaultProps = {
	required: false,
	alignRight: false,
};
